export const RTO_REASONS = [
    {
      key: "008",
      value: "Order / fulfillment not ready for pickup"
    },
    {
      key: "011",
      value: "Buyer not found or cannot be contacted",
      
    },
    {
      key: "012",
      value: "Buyer does not want product any more",
    },
    {
      key: "013",
      value: "Buyer refused to accept delivery",
    },
    {
      key: "014",
      value: "Address not found",
      
    },
    {
      key: "015",
      value: "Buyer not available at location",
      
    },
    {
        key: "016",
        value: "Accident / rain / strike / vehicle issues",
    },
    {
      key: "017",
      value: "Order delivery delayed or not possible",
    },
    {
      key: "020",
      value: "Order lost in transit",
      
    },
    {
        key: "021",
        value: "Packed order not complete",
        
      },
  ];
  